/* header-nav-marker.js
 * Sliding pill marker for the desktop header menu.
 * - Slides behind the hovered / keyboard-focused top-level item.
 * - Returns to the current page (active) item on mouse-leave.
 * - Measures positions with getBoundingClientRect, so it works in RTL too.
 * - Respects prefers-reduced-motion (the pill just fades, no slide).
 */
(function () {
  function initNav(nav) {
    if (!nav || nav.dataset.navMarkerReady === '1') return;
    var marker = nav.querySelector('[data-nav-marker]');
    if (!marker) return;

    var items = Array.prototype.slice.call(
      nav.querySelectorAll(
        '.list-menu--inline > li > a.header__menu-item, .list-menu--inline > li > header-menu > details > summary.header__menu-item'
      )
    );
    if (!items.length) return;
    nav.dataset.navMarkerReady = '1';

    var activeEl = null;
    items.forEach(function (el) {
      if (
        el.getAttribute('aria-current') === 'page' ||
        el.querySelector('.header__active-menu-item')
      ) {
        activeEl = el;
      }
    });

    function place(el, animate) {
      if (!el) return;
      var r = el.getBoundingClientRect();
      if (!r.width) return; // hidden (e.g. mobile) — skip
      var nr = nav.getBoundingClientRect();
      if (!animate) marker.classList.add('no-anim');
      marker.style.left = r.left - nr.left + 'px';
      marker.style.top = r.top - nr.top + 'px';
      marker.style.width = r.width + 'px';
      marker.style.height = r.height + 'px';
      marker.classList.add('is-visible');
      if (!animate) {
        void marker.offsetWidth; // flush layout so the next move animates
        requestAnimationFrame(function () {
          marker.classList.remove('no-anim');
        });
      }
    }

    function mark(el) {
      items.forEach(function (item) { item.classList.remove('is-marked'); });
      if (el) el.classList.add('is-marked');
    }

    function reset() {
      mark(activeEl);
      if (activeEl) {
        place(activeEl, true);
      } else {
        marker.classList.remove('is-visible');
      }
    }

    items.forEach(function (el) {
      el.addEventListener('mouseenter', function () { mark(el); place(el, true); });
      el.addEventListener('focus', function () { mark(el); place(el, true); });
    });

    nav.addEventListener('mouseleave', reset);
    nav.addEventListener('focusout', function (e) {
      if (!nav.contains(e.relatedTarget)) reset();
    });

    // Initial placement on the active item (no slide-in from the corner).
    if (activeEl) {
      requestAnimationFrame(function () { mark(activeEl); place(activeEl, false); });
    }

    // Keep the pill aligned after resize / late web-font layout shifts.
    var rt;
    function reposition() {
      var current = nav.querySelector('.header__menu-item.is-marked') || activeEl;
      if (current) place(current, false);
    }
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(reposition, 120);
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(reposition);
    }
  }

  function boot() {
    var navs = document.querySelectorAll('.header__inline-menu[data-nav-marker-root]');
    for (var i = 0; i < navs.length; i++) initNav(navs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
